// eslint-disable-next-line import/prefer-default-export
export const constants = {
  ALLOWED_POSTAL_CODES: [],
  DEFAULT_LOCATION: 1,
  DEFAULT_DELIVERY_METHOD: 1,
  DEFAULT_PAYMENT_METHOD: 1,
  DELIVERY_METHOD_TYPE_ONSITE: 1,
  DELIVERY_METHOD_TYPE_DELIVER: 2,
  DELIVERY_METHOD_TYPE_TAKEAWAY: 3,
  DELIVERY_METHOD_TYPE_WOLT: 12,
  PAYMENT_METHOD_TYPE_INPERSON: 0,
  PAYMENT_METHOD_TYPE_VALITOR: 1,
  PAYMENT_METHOD_TYPE_BORGUN: 2,
  PAYMENT_METHOD_ID_AUR: 5,
  PAYMENT_METHOD_TYPE_INVOICE: 100,
  PAYMENT_METHOD_TYPE_INVOICE_INTERNAL: 101,
  ORDER_STATUS_UNPAYED: 1,
  PAYMENT_METHOD_TYPE_VALITORPAGE: 4,
  PAYMENT_METHOD_TYPE_VERIFONECHECKOUT: 11,
  PAYMENT_METHOD_TYPE_TEYAPAGE: 12,
  EMAIL_API_KEY: 'fdd37c01217db8d828677b780df9b612',
  SESSION_COOKIE_USER_ID: 'userUid',
  SESSION_COOKIE_LOCATION_ID: 'locationUid',
};
